// © 2026 AttainIP Engineering
import { Navigate } from 'react-router-dom';
import { getCurrentUser, isPlatformAdmin } from '@/lib/auth';

// Defence-in-depth for platform_admin-only pages. The whole console is already
// platform_admin-gated at RequireAuth; this is a second guard. A non-
// platform_admin never reaches here (bounced at the front door), but if they
// did, send them out to /dashboard — never to a firm page inside the console.
export function RequirePlatformAdmin({ children }: { children: React.ReactNode }) {
  const user = getCurrentUser();
  if (!isPlatformAdmin(user)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
